import CardContainer from "../../components/card_container";
import { useState, useRef, createRef, useEffect } from "react";
import { ReactComponent as IconAddCircle } from "../../assets/icons/icon_add_circle.svg";
import { ReactComponent as IconBulkUpload } from "../../assets/icons/icon_bulk_upload.svg";
import { ReactComponent as IconClose } from "../../assets/icons/icon_close.svg";
import CustomModalMaster from "../../components/custom_modal_master";
import useFormStyle from "./hookForm";
import IconUpload from "../../assets/icons/icon_upload.svg";
import Button from "../../components/button";
import "./style_accent.scss";
import InputImage from "../../components/input_image_new";
import IconPreviewImage from "../../assets/icons/icon_preview_image.svg";
import IconDeleteAlt from "../../assets/icons/icon_delete_alt.svg";
import ImageSlider from "../../components/image_slider";
import LoadingModal from "../../components/loading_modal";
import JSZip from "jszip";

const DetailStyleAccentPage = () => {
  const [file, setFile] = useState(null);
  const inputImageRef = useRef(null);
  const handleClick = () => {
    inputImageRef.current.click();
  };
  const {
    form,
    fileZip,
    index,
    isModal,
    isModalAsset,
    isModalDetail,
    isChange,
    isLoading,
    detailFabric,
    listData,
    allImages,
    handleHover,
    handleBulkUploadOpen,
    handleBulkUploadClose,
    handleAssetUploadOpen,
    handleAssetUploadClose,
    handleImageChange,
    handleBulkUploadZip,
    handleImageChangeAsset,
    handleDetail,
    handleDetailClose,
    handleDelete,
    handleCancelChange,
    handleSubmit,
  } = useFormStyle();

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);

    // if (file) {
    //     // Process the ZIP or RAR file
    //     handleBulkUploadZip(file)
    // } else {
    //     alert('Please select a file first.');
    // }
  };
  useEffect(() => {
    if (file) {
      // Process the ZIP or RAR file
      handleBulkUploadZip(file);
    }
  }, [file]);

  const handleUpload = () => {
    if (file) {
      // Process the ZIP or RAR file
      handleBulkUploadZip(file);
    }
  };

  return (
    <>
      <CardContainer title={"Style"} isBack={true}>
        <div className="card-header-style">
          <div className="card-summary">
            <div className="detail-fabric-style">
              <div className="stock-code">
                {detailFabric ? detailFabric.stock_code : ""}
              </div>
              <div className="name-fabric">
                {detailFabric ? detailFabric.fabric_name : ""}
              </div>
              <div className="material-fabric">
                {detailFabric ? detailFabric.material : ""}
              </div>
            </div>
            <div>
              <img
                src={detailFabric ? detailFabric.fabric_image : ""}
                className="image-fabric"
              />
            </div>
            {isChange ? (
              <></>
            ) : (
              <div
                className="detail-bulk-upload pointer"
                onClick={handleBulkUploadOpen}
              >
                <IconBulkUpload className="icon" />
                Bulk Upload
              </div>
            )}
          </div>
        </div>
        {/* <div>
                    <input type="file" onChange={handleFileChange} accept=".zip,.rar" />
                    <button onClick={handleUpload}>Upload and Unzip</button>
                </div> */}

        <div className="expanded-y ">
          <div
            className={
              isChange
                ? "height-form-with-footer"
                : "height-form-without-footer"
            }
          >
            {!Array.isArray(listData)
              ? console.log(listData)
              : listData.map((e, listIndex) => (
                  <div key={listIndex}>
                    <div className="detail-style-decoration">
                      <div className="detail-title-style">
                        <img
                          src={e.image}
                          style={{
                            height: "80px",
                            width: "80px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="detail-title-name">{e.name}</div>
                      </div>
                      <hr />
                      {["front", "back", "folded"].map(
                        (viewType) =>
                          e[viewType] &&
                          e[viewType].length > 0 && (
                            <div key={viewType}>
                              <div className="view-type-title">
                                {viewType.toUpperCase()}
                              </div>
                              <div
                                className="expanded-x"
                                style={{
                                  marginTop: "24px",
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "16px",
                                }}
                              >
                                {e[viewType].map((ex, exIndex) => (
                                  <div key={exIndex} className="pointer-style">
                                    {ex.file !== "" ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          display: "flex",
                                        }}
                                        onMouseEnter={() =>
                                          handleHover(ex, true)
                                        }
                                        onMouseLeave={() =>
                                          handleHover(ex, false)
                                        }
                                      >
                                        <div className="detail-data-style-with-file">
                                          {ex.code
                                            .toLowerCase()
                                            .includes("folded") ? (
                                            <img
                                              src={ex.file}
                                              style={{
                                                color: "red",
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                transform: "scale(1.5)",
                                                objectPosition: "40% top",
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={ex.file}
                                              style={{
                                                color: "red",
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                transform: "scale(1.7)",
                                                objectPosition: "40% -10%",
                                              }}
                                            />
                                          )}
                                        </div>
                                        {ex.isHover && (
                                          <div
                                            className="detail-hover-option"
                                            style={{
                                              width: "100%",
                                              height: "120%",
                                              gap: "16px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <img
                                              src={IconPreviewImage}
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                              }}
                                              onClick={() => handleDetail(ex)}
                                            />
                                            <img
                                              src={IconDeleteAlt}
                                              style={{
                                                width: "50px",
                                                height: "50px",
                                              }}
                                              onClick={() => handleDelete(ex)}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div
                                        className="detail-data-style"
                                        onMouseEnter={() =>
                                          handleHover(ex, true)
                                        }
                                        onMouseLeave={() =>
                                          handleHover(ex, false)
                                        }
                                      >
                                        {ex.isHover ? (
                                          <IconAddCircle
                                            style={{
                                              width: "100p%",
                                              height: "100%",
                                              color: "#999999",
                                            }}
                                            onClick={() =>
                                              handleAssetUploadOpen(ex)
                                            }
                                          />
                                        ) : (
                                          <img
                                            src={ex.image}
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                            }}
                                          />
                                        )}
                                      </div>
                                    )}
                                    {(ex.code
                                      .toLowerCase()
                                      .includes("folded") &&
                                      ex.code
                                        .toLowerCase()
                                        .includes("chestpocket")) ||
                                    (ex.code.toLowerCase().includes("folded") &&
                                      ex.code
                                        .toLowerCase()
                                        .includes("cuffs")) ? (
                                      <div
                                        className="detail-code-style"
                                        style={{ marginTop: "30px" }}
                                      >
                                        {ex.name}
                                      </div>
                                    ) : (
                                      <div className="detail-code-style">
                                        {ex.name}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                ))}
          </div>
        </div>
        {isChange ? (
          <>
            <hr />
            <div className="footer-form">
              <Button
                type="button"
                className="btn-outline-primary"
                style={{ marginRight: "8px" }}
                title="Cancel"
                onClick={handleCancelChange}
              />
              <Button
                type="button"
                className="btn-primary"
                title="Save"
                onClick={handleSubmit}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </CardContainer>
      <CustomModalMaster
        withHeader={true}
        title={"Bulk Upload"}
        isOpen={isModal}
        onRequestClose={handleBulkUploadClose}
      >
        <div style={{ color: "#999999", fontSize: "14px" }}>
          Browse some files below!
        </div>
        <InputImage
          id="image"
          label={"Asset Image"}
          isMultiple={false}
          onChange={handleFileChange}
        />
        <div
          style={{
            color: "#006BB7",
            display: "flex",
            fontSize: "14px",
            justifyContent: "end",
          }}
        >
          The file must be in image format (svg, png, jpg).
        </div>
      </CustomModalMaster>
      <CustomModalMaster
        withHeader={true}
        title={"Upload Asset"}
        isOpen={isModalAsset}
        onRequestClose={handleAssetUploadClose}
      >
        <div style={{ color: "#999999", fontSize: "14px" }}>
          Browse your files below!
        </div>
        <InputImage
          id="image"
          label={"Asset Image"}
          isMultiple={false}
          onChange={handleImageChangeAsset}
        />
        <div
          style={{
            color: "#006BB7",
            display: "flex",
            fontSize: "14px",
            justifyContent: "end",
          }}
        >
          The file must be in image format (svg, png, jpg).
        </div>
      </CustomModalMaster>
      <CustomModalMaster isOpen={isModalDetail}>
        <IconClose className="icon-close" onClick={handleDetailClose} />
        <ImageSlider images={allImages} initialIndex={index} />
      </CustomModalMaster>
      <LoadingModal isLoading={isLoading} />
    </>
  );
};
export default DetailStyleAccentPage;
